import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';

import axiosInstance from '../../utility/axiosInstance';
import {handleAxiosError} from "../../helpers/handleAxiosError";
interface Image {
    id: string;
    name: string;
    status: string;
    size: number;
    visibility: string;
    metadata?: {
        base_image_name?: string;
        original_instance_id?: string;
        [key: string]: any;
    };
    // Glance v2 often puts properties directly on the object too
    base_image_name?: string;
    [key: string]: any;
}

interface ImagesState {
    data: Image[];
    status: 'idle' | 'loading' | 'succeeded' | 'failed';
    error: string | null;
}

const initialState: ImagesState = {
    data: [],
    status: 'idle',
    error: null,
};

export const fetchImages = createAsyncThunk(
    'images/fetchImages',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get('/v1/images');
            const images = response.data;
            return images.filter((image: any) => !image.name.toLowerCase().includes('deepseek'));
        } catch (error) {
            console.error("Failed to fetch DNS:", error);
            return rejectWithValue(handleAxiosError(error));
        }
    }
);

const imagesSlice = createSlice({
    name: 'images',
    initialState,
    reducers: {
        resetImages: () => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchImages.pending, (state) => {
                state.status = 'loading';
                state.error = null;
            })
            .addCase(fetchImages.fulfilled, (state, action: PayloadAction<Image[]>) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchImages.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            });
    },
});

export const { resetImages } = imagesSlice.actions;
export default imagesSlice.reducer;